import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { globalIntegrationCreateRoute } from '@jira/router-routes__eoc-integration-automation-routes/src/globalIntegrationCreateRoute.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { resources as integrationAutomationResources } from '@atlassian/eoc-integration-automation/resources';
import type { Route, RouteResources } from '@atlassian/react-resource-router';
import { IntegrationAutomation } from './ui/IntegrationAutomation.tsx';
import { IntegrationCreate } from './ui/IntegrationCreate.tsx';
import { LazyIntegrationAutomation } from './ui/async.tsx';

const getNavigationSpecifications = () => {
	return {
		sidebarId: SidebarIdOperationsGeneralConfiguration,
	};
};

export const globalIntegrationCreateRouteEntry: Route = createEntry(
	globalIntegrationCreateRoute,
	() => ({
		group: 'eoc',
		basePath: '/jira/settings/products/ops',
		// eslint-disable-next-line no-restricted-syntax
		component: IntegrationAutomation,
		slot: IntegrationCreate,

		// Platform types these against the published `react-resource-router`, which Jira aliases to its
		// own fork at build time, so the two `RouteResource` types are unrelated to TypeScript.
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			integrationAutomationResources.configuredIntegrationsResource,
			integrationAutomationResources.integrationListResource,
			integrationAutomationResources.userAccessRightsResource,
		] as RouteResources,

		navigation: {
			menuId: MenuIdSettings,
			...getNavigationSpecifications(),
		},

		forPaint: [LazySidebarContent, LazyAtlassianNavigation, LazyIntegrationAutomation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
